import { Customer } from '@/types/TCRMLead';
import { FiPhone, FiMail, FiX, FiUser } from 'react-icons/fi';

interface CustomerHeaderProps {
	customer: Customer;
	onClose: () => void;
}

export const CustomerHeader: React.FC<CustomerHeaderProps> = ({ customer, onClose }) => {
	const getInitials = (name?: string) => {
		if (!name) {
			return 'N/A';
		}
		return name
			.split(' ')
			.map((n) => n[0])
			.join('')
			.toUpperCase();
	};

	const displayName = customer.name || 'Unknown Customer';
	const displayPhone = customer.number || 'No phone number';
	const displayEmail = customer.email || 'No email';

	return (
		<div className="p-6 border-b bg-gray-50">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-6">
					<div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white text-xl font-semibold">
						{customer.name ? getInitials(customer.name) : <FiUser className="w-6 h-6" />}
					</div>
					<div>
						<h2 className="text-2xl font-bold text-gray-900 mb-3">{displayName}</h2>
						<div className="flex items-center gap-6 text-sm text-gray-600">
							<div className="flex items-center gap-2">
								<FiPhone className="w-4 h-4" />
								<span className={customer.number ? '' : 'italic text-gray-400'}>
									{displayPhone}
								</span>
							</div>
							{customer.email && (
								<div className="flex items-center gap-2">
									<FiMail className="w-4 h-4" />
									{displayEmail}
								</div>
							)}
						</div>
					</div>
				</div>
				<button
					onClick={onClose}
					className="p-2 text-gray-500 hover:bg-gray-100 rounded-lg transition-colors"
				>
					<FiX className="w-6 h-6" />
				</button>
			</div>
		</div>
	);
};
